/* Évinel · fiche produit desktop
   1. Relais du bouton d'ajout au panier par la barre basse.
   2. Visionneuse plein écran : une image par page, calée sur la hauteur.

   Le collage de la colonne est entièrement natif (CSS). Aucun `top` piloté
   au défilement, aucune modification du DOM. */

/* ---------- 1. Relais du bouton ---------- */
(function(){
  var barre = document.getElementById('ev-sticky');
  var cta   = document.getElementById('ev-cta');
  if(!barre || !cta) return;

  var MARGE = 60;   /* on bascule avant la disparition complète du bouton */

  function ajuste(){
    var r = cta.getBoundingClientRect();
    barre.classList.toggle('visible', r.bottom < MARGE || r.top > window.innerHeight - MARGE);
  }

  var enAttente = false;
  function planifie(){
    if(enAttente) return;
    enAttente = true;
    requestAnimationFrame(function(){ ajuste(); enAttente = false; });
  }

  window.addEventListener('scroll', planifie, {passive:true});
  window.addEventListener('resize', planifie, {passive:true});
  window.addEventListener('load', planifie);
  document.addEventListener('toggle', planifie, true);
  ajuste();
})();

/* ---------- 2. Visionneuse ---------- */
(function(){
  var galerie = document.getElementById('ev-galerie');
  if(!galerie) return;

  var grandEcran = window.matchMedia('(min-width:1001px)');
  var overlay, defile, compteur, prec, suiv, positionPage = 0;

  function urlGrande(src){
    return src.replace(/([?&])width=\d+/, '$1width=2400');
  }

  function coque(){
    overlay = document.createElement('div');
    overlay.className = 'ev-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Images du produit');
    overlay.innerHTML =
      '<button type="button" class="ev-zoom-fermer" aria-label="Fermer">×</button>' +
      '<button type="button" class="ev-zoom-nav ev-zoom-prec" aria-label="Image précédente">' +
        '<svg viewBox="0 0 24 24"><path d="M18 15l-6-6-6 6"/></svg></button>' +
      '<button type="button" class="ev-zoom-nav ev-zoom-suiv" aria-label="Image suivante">' +
        '<svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button>' +
      '<div class="ev-zoom-defile"></div>' +
      '<div class="ev-zoom-compteur" aria-hidden="true"></div>';
    defile   = overlay.querySelector('.ev-zoom-defile');
    compteur = overlay.querySelector('.ev-zoom-compteur');
    prec     = overlay.querySelector('.ev-zoom-prec');
    suiv     = overlay.querySelector('.ev-zoom-suiv');

    overlay.addEventListener('click', function(e){
      if(e.target.closest('.ev-zoom-nav')) return;
      if(e.target === overlay || e.target === defile || e.target.tagName === 'FIGURE' || e.target.closest('.ev-zoom-fermer')) fermer();
    });
    prec.addEventListener('click', function(){ va(-1); });
    suiv.addEventListener('click', function(){ va(1); });
    defile.addEventListener('scroll', majCompteur, {passive:true});
    document.body.appendChild(overlay);
  }

  /* Reconstruit à chaque ouverture : la 1re image change avec la variante.
     L'image ouverte et ses deux voisines sont chargées en priorité, sinon
     celle qu'on vient de cliquer apparaît vide une fraction de seconde. */
  function remplir(index){
    var sources = Array.prototype.slice.call(galerie.querySelectorAll('img'));
    defile.innerHTML = '';
    sources.forEach(function(src, i){
      var fig = document.createElement('figure');
      var img = document.createElement('img');
      var proche = Math.abs(i - index) <= 1;
      img.src = urlGrande(src.currentSrc || src.src);
      img.alt = src.alt || '';
      img.loading = proche ? 'eager' : 'lazy';
      if(proche) img.fetchPriority = 'high';
      img.decoding = proche ? 'sync' : 'async';
      fig.appendChild(img);
      defile.appendChild(fig);
    });
  }

  function indexCourant(){
    if(!defile.clientHeight) return 0;
    return Math.round(defile.scrollTop / defile.clientHeight);
  }

  function majCompteur(){
    var n = defile.children.length;
    if(!n) return;
    var i = Math.min(n - 1, Math.max(0, indexCourant()));
    compteur.textContent = (i + 1) + ' / ' + n;
    prec.disabled = (i === 0);
    suiv.disabled = (i === n - 1);
  }

  function va(sens){
    var n = defile.children.length;
    var i = Math.min(n - 1, Math.max(0, indexCourant() + sens));
    defile.scrollTo({ top: i * defile.clientHeight, behavior: 'smooth' });
  }

  function ouvrir(index){
    if(!overlay) coque();
    remplir(index);
    positionPage = window.scrollY;
    document.body.classList.add('ev-zoom-ouvert');
    document.body.style.top = (-positionPage) + 'px';
    overlay.classList.add('visible');
    /* saut direct sur l'image cliquée, sans animation à l'ouverture */
    var fluide = defile.style.scrollBehavior;
    defile.style.scrollBehavior = 'auto';
    defile.scrollTop = index * defile.clientHeight;
    defile.style.scrollBehavior = fluide || '';
    majCompteur();
    overlay.querySelector('.ev-zoom-fermer').focus();
  }

  function fermer(){
    if(!overlay) return;
    overlay.classList.remove('visible');
    document.body.classList.remove('ev-zoom-ouvert');
    document.body.style.top = '';
    window.scrollTo(0, positionPage);
  }

  galerie.addEventListener('click', function(e){
    if(!grandEcran.matches) return;
    var img = e.target.closest('img');
    if(!img) return;
    var liste = Array.prototype.slice.call(galerie.querySelectorAll('img'));
    ouvrir(liste.indexOf(img));
  });

  document.addEventListener('keydown', function(e){
    if(!overlay || !overlay.classList.contains('visible')) return;
    if(e.key === 'Escape'){ fermer(); return; }
    if(e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'PageDown'){ e.preventDefault(); va(1); }
    if(e.key === 'ArrowUp'   || e.key === 'ArrowLeft'  || e.key === 'PageUp'){   e.preventDefault(); va(-1); }
  });

  window.addEventListener('resize', function(){
    if(overlay && overlay.classList.contains('visible')) majCompteur();
  }, {passive:true});
})();
